

































import { ModalConfig } from "@/components/root/modal";
import Modal from "@/components/root/modal/Modal.vue";
import Vue from "vue";

export default Vue.extend({
  components: { Modal },
  props: ["modalData"],
  setup() {
    const config: ModalConfig = {
      blank: true,
      desc: "",
      title: "",
      backdropDismiss: true,
      width: "55rem",
      height: "auto",
      withTopRightCloseBtn: true,
    };
    return {
      config,
    };
  },
});
